import { useCallback } from 'react';
import { useAppContext } from '../contexts/AppContext';
import { normalizeProjectName, extractProjectName } from '../utils/validation';

/**
 * Hook to filter items based on the active project.
 * Returns a function checks if an item belongs to the active project.
 */
export const useProjectFilter = () => {
    const { activeProject, allData } = useAppContext();

    const isItemInProject = useCallback((projName?: string, epochId?: number) => {
        if (activeProject === 'all') return true;
        const activeProjectNormalized = normalizeProjectName(activeProject);

        if (projName) {
            return normalizeProjectName(projName) === activeProjectNormalized;
        }

        if (!epochId) return false;

        // Check iteration history for epoch mapping
        const epoch = allData.iterationHistory?.find(e =>
            (e.epochNumber || e.iteration) === epochId
        );
        if (!epoch) return false;

        const projectName = extractProjectName(epoch.epochName || '');
        return normalizeProjectName(projectName) === activeProjectNormalized;
    }, [activeProject, allData.iterationHistory]);

    return { isItemInProject };
};
